import React from 'react';

export function Field({ label, htmlFor, error, children }) {
  return (
    <div className="form-field">
      {label && <label htmlFor={htmlFor}>{label}</label>}
      {children}
      {error && <div className="field-error">{error}</div>}
    </div>
  );
}

export default Field;
